var _title, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoFirehydrant = function SvgLogoFirehydrant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Firehydrant")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5300",
    d: "m22.992 29.702-2.155-7.12-4.723 4.873-1.824-6.146L26.694 8.503c-14.447 0-19.502 6.714-18.12 12.319l2.734 10.532c1.437 4.954-3.729 7.526-5.138 8.122 2.735.08 4.862-.054 6.768-.65 3.646-1.002 6.05-3.466 10.055-9.124Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5300",
    d: "M36.693 16.652c-1.437-4.954 3.729-7.526 5.138-8.122-2.735-.081-4.862.054-6.768.65-3.674 1.001-6.077 3.465-10.082 9.124l2.154 7.12 4.724-4.873 1.823 6.146-12.403 12.779c14.447 0 19.502-6.715 18.12-12.32l-2.706-10.504Z",
    opacity: 0.6
  })));
};
export default SvgLogoFirehydrant;